<template>
    <div class="position-relative">
        <v-app class="p-4">
            <div class="p-0 mt-5 pt-5 col-md-8 mx-auto" style="border: none!important;">
                <p class="mt-5">بسته موردنظر خود را با پرکردن تمامی فیلدهای درخواستی ایجاد کنید.</p>
                <v-row class="mt-5">
                    <v-col cols="12" md="6">
                        <v-text-field
                                v-model="title"
                                label="عنوان محصول"
                                required
                                counter="80"
                                maxLength="80"
                                clearable
                                clear-icon="mdi-close-circle-outline"
                                dense
                                outlined
                                class="mt-1"
                                prepend-inner-icon="fa fa-pencil-alt"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <admin-category parent-name="دسته بندی"></admin-category>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                                v-model="priceSeperator"
                                label="مبلغ"
                                outlined
                                @keypress="onlyNumber($event)"
                                required
                                clearable
                                clear-icon="mdi-close-circle-outline"
                                dense
                                suffix="﷼"
                                prepend-inner-icon="fa fa-pencil-alt"
                                class="mt-1"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                                label="تخفیف"
                                v-model="discount"
                                :hint="'مبلغ نهایی با اعمال تخفیف : ' + ' ' + finalPriceCounter + '﷼'"
                                outlined
                                clearable
                                clear-icon="mdi-close-circle-outline"
                                @keypress="onlyNumber($event)"
                                required
                                suffix="%"
                                dense
                                prepend-inner-icon="fa fa-pencil-alt"
                                class="mt-1"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <image-uploader limit="10"></image-uploader>
                    </v-col>
                    <v-col cols="12" md="6">
                        <file-uploader></file-uploader>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-autocomplete label="نوع بانک اطلاعاتی" class="mt-1" outlined dense :items="banks"
                                        v-model="bankType"
                                        item-text="name"
                                        prepend-inner-icon="fa fa-pencil-alt"
                        ></v-autocomplete>
                        <v-switch
                                v-model="country"
                                label="کشوری"
                                color="indigo"
                                hide-details
                        ></v-switch>

                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                                v-model="recordCount"
                                label="تعداد رکورد"
                                outlined
                                @keypress="onlyNumber($event)"
                                required
                                clearable
                                clear-icon="mdi-close-circle-outline"
                                dense
                                prepend-inner-icon="fa fa-pencil-alt"
                                class="mt-1"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="country==false">
                    <v-col cols="12" md="6">
                        <province-selector></province-selector>
                    </v-col>

                    <v-col cols="12" md="6">
                        <city-selector></city-selector>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                                label="توضیحات"
                                v-model="description"
                                outlined
                                required
                                dense
                                clearable
                                clear-icon="mdi-close-circle-outline"
                                rows="5"
                                prepend-inner-icon="fa fa-pencil-alt"
                                class="mt-1"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <div class="col-md-12 text-left">
                    <v-btn @click="createPack" class="mt-5 submit-btn float-left">
                        <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                        ثبت تعرفه
                    </v-btn>
                </div>
            </div>
        </v-app>
    </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import AdminCategory from "../mainComponents/adminCategory";
import {Axios2, Bus} from "../../../main";
import ImageUploader from "../mainComponents/imageUploader";
import FileUploader from "../mainComponents/fileUploader";
import CitySelector from "../mainComponents/citySelector";
import ProvinceSelector from "../mainComponents/provinceSelector";

export default {
    name: "createPack",
    components: {ProvinceSelector, CitySelector, FileUploader, ImageUploader, AdminCategory, TitleRibbon},
    data() {
        return {
            title: '',
            recordCount: '',
            category: false,
            description: '',
            price: 0,
            bankType: false,
            finalPrice: '',
            discount: '',
            image: [],
            banks: [
                {name: 'بانک اطلاعاتی شماره', value: 'phone'},
                {name: 'بانک اطلاعاتی معمولی', value: 'data'},
            ],
            file: '',
            province: undefined,
            city: undefined,
            country: ''
        }
    },
    methods: {
        createPack() {
            Axios2.post('admin/archive', {
                "category_id": this.category,
                "province": this.province !== null ? this.province : undefined,
                "city": this.city != null ? this.city : undefined,
                "title": this.title,
                "count": this.recordCount,
                "description": this.description,
                "amount": this.price,
                "discount": this.discount,
                "images": this.image,
                "file": this.file,
                "type": this.bankType
            }).then(() => {
                this.$modal.success('موفقیت‌ آمیز!', 'دسته موردنظر شما با موفقیت ساخته شد.');
                Bus.$emit('resetValues', true);
                this.modal();

            }).catch((error) => {
                this.$modal.error('خطا!', '', Object.keys(error.response.data.errors).map((key) => {
                    return error.response.data.errors[key][0]
                }).join('\n'));
            });
        },
    },
    computed: {
        priceSeperator: {
            set(value) {
                this.price = value.replaceAll(',', '');
            },
            get() {
                return this.$options.filters.currency(this.price);
            }
        },
        finalPriceCounter() {
            this.finalPrice = (this.price * this.discount) / 100;
            return this.$options.filters.currency(this.price - this.finalPrice);
        }
    },
    mounted() {

        Bus.$on('getCategory', (value) => {
            this.category = value;
        });

        Bus.$on('getImage', (value) => {
            this.image = value;
        });

        Bus.$on('getFile', (value) => {
            this.file = value;
        });

        Bus.$on('getCity', (value) => {
            if (this.country === false || this.country === "")
                this.city = value;
        });

        Bus.$on('getProvince', (value) => {
            if (this.country === false || this.country === "")
                this.province = value;
        });
    }
}
</script>

<style>
.fa-pencil-alt {
    font-size: 1.3rem !important;
}
</style>